import { render, staticRenderFns } from "./StaffTimetable.vue?vue&type=template&id=0a5d2ae8"
import script from "./StaffTimetable.vue?vue&type=script&lang=js"
export * from "./StaffTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports